<template>
  <div id="app-lease-login">
    <!-- Background -->
    <div class="login-container">
      <!-- Login box -->
      <div class="login-box">
        <div class="login-title">場地租借管理系統</div>
        <div class="login-subtitle">登入</div>
        
        <!-- Account input -->
        <div class="login-form">
          <div class="form-item">
            <label class="form-label">帳號</label>
            <input 
              type="text" 
              v-model="loginForm.username" 
              class="form-input"
              placeholder="請輸入帳號"
              @keyup.enter="handleLogin"
            />
          </div>
          
          <!-- Password input -->
          <div class="form-item">
            <label class="form-label">密碼</label>
            <input 
              type="password" 
              v-model="loginForm.password" 
              class="form-input"
              placeholder="請輸入密碼"
              @keyup.enter="handleLogin"
            />
          </div>
          
          <!-- Error message -->
          <div class="error-message" v-if="errorMessage">
            {{ errorMessage }}
          </div>
          
          <!-- Login button -->
          <div class="form-item">
            <button class="login-button" @click="handleLogin">
              登入
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';

export default {
  name: 'LeaseLogin',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      errorMessage: ''
    };
  },
  methods: {
    // Validate login
    validateLogin(username, password) {
        const validUsername = 'admin';
        const validPasswordHash = '359d5d2069e6978d28ff26791f377b27688b6c39bea30a4a1436710cc8c80dba04d7c335090e959be9f0ec292223fdb89dbe9076d85cde9fcdfe5ff7c1f47d15';

          // Hash the input password with SHA512
        const passwordHash = CryptoJS.SHA512(password).toString();

        return username === validUsername && passwordHash === validPasswordHash;
    },
    
    // Handle login
    handleLogin() {
      // Clear error message
      this.errorMessage = '';

      // Validate fields are not empty
      if (!this.loginForm.username || !this.loginForm.password) {
        this.errorMessage = '請輸入帳號和密碼';
        return;
      }
      
      // Validate credentials
      if (this.validateLogin(this.loginForm.username, this.loginForm.password)) {
        // Login successful, redirect to venue rental page
        this.$alert('登入成功', '提示', {
          confirmButtonText: '確定',
          callback: () => {
            // Save login state to store here
            this.$store.state.isLeaseLogin = true;
            
            // Redirect to venue rental management page
            this.$router.push({
              name: 'Lease',
              query: this.$route.query
            });
          }
        });
      } else {
        // Login failed
        this.errorMessage = '帳號或密碼錯誤';
        this.$alert('帳號或密碼錯誤', '提示', {
          confirmButtonText: '確定'
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
#app-lease-login {
  width: 100%;
  height: 100vh;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  
  .login-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .login-box {
    width: 45rem;
    background-color: #fff;
    border-radius: 1rem;
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.3);
    padding: 4rem 5rem;
    
    .login-title {
      font-size: 2.6rem;
      color: #0e293f;
      text-align: center;
      margin-bottom: 1rem;
      font-weight: bold;
    }
    
    .login-subtitle {
      font-size: 2rem;
      color: #636e72;
      text-align: center;
      margin-bottom: 3rem;
    }
    
    .login-form {
      width: 100%;
      
      .form-item {
        margin-bottom: 2.5rem;
        
        .form-label {
          display: block;
          font-size: 1.6rem;
          color: #0e293f;
          margin-bottom: 1rem;
          font-weight: 500;
        }
        
        .form-input {
          width: 100%;
          height: 4.5rem;
          padding: 0 1.5rem;
          font-size: 1.6rem;
          border: 0.2rem solid #dfe6e9;
          border-radius: 0.5rem;
          outline: none;
          transition: all 0.3s;
          box-sizing: border-box;
          
          &:focus {
            border-color: #667eea;
          }
          
          &::placeholder {
            color: #b2bec3;
          }
        }
      }
      
      .error-message {
        color: #d63031;
        font-size: 1.4rem;
        margin-top: -1.5rem;
        margin-bottom: 2rem;
        text-align: center;
      }
      
      .login-button {
        width: 100%;
        height: 4.5rem;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
        font-size: 1.8rem;
        font-weight: bold;
        border: none;
        border-radius: 0.5rem;
        cursor: pointer;
        transition: all 0.3s;
        outline: none;
        
        &:hover {
          transform: translateY(-0.2rem);
          box-shadow: 0 0.5rem 1.5rem rgba(102, 126, 234, 0.4);
        }
        
        &:active {
          transform: translateY(0);
        }
      }
    }
  }
}

// Responsive design
@media screen and (max-width: 768px) {
  #app-lease-login {
    .login-box {
      width: 90%;
      padding: 3rem 2.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/leaseLogin.vue